import { render, staticRenderFns } from "./r-plinko-obstacle-config-panel.vue?vue&type=template&id=f72e1fca"
import script from "./r-plinko-obstacle-config-panel.vue?vue&type=script&lang=js"
export * from "./r-plinko-obstacle-config-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f72e1fca')) {
      api.createRecord('f72e1fca', component.options)
    } else {
      api.reload('f72e1fca', component.options)
    }
    module.hot.accept("./r-plinko-obstacle-config-panel.vue?vue&type=template&id=f72e1fca", function () {
      api.rerender('f72e1fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-obstacle-config-panel.vue"
export default component.exports